import { heroStats } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center bg-background-50 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent-100 text-accent-800 text-sm font-medium mb-6">
              <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
              实时更新 · 瓜料聚合
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-foreground-950 leading-tight mb-4">
              爆料吃瓜<span className="text-primary-500"> · </span>全网热门八卦一站式导航
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 mb-6">
              汇集最新爆料，追踪实时瓜料，畅享吃瓜乐趣
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-[640px] mx-auto lg:mx-0 mb-8">
              爆料吃瓜是一个专业的吃瓜网站与爆料网站导航聚合平台，覆盖娱乐圈八卦、网红爆料、综艺内幕、选秀动态等全方位吃瓜资源。
              我们7×24小时实时追踪全网热门八卦，从微博热搜到豆瓣小组，从贴吧爆料到小红书热议，帮你一站式掌握最新瓜料。
              当前热门：顶流塌房事件持续发酵，多个品牌连夜解约，相关话题讨论量已突破千万。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              {heroStats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-heading text-primary-500">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-foreground-500 mt-1">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#topics"
                className="whitespace-nowrap px-8 py-3.5 rounded-full text-base font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-all cursor-pointer"
              >
                <i className="ri-fire-line mr-2"></i>
                立即吃瓜
              </a>
              <a
                href="#contact"
                className="whitespace-nowrap px-8 py-3.5 rounded-full text-base font-semibold border-2 border-primary-500 text-primary-500 hover:bg-primary-50 transition-all cursor-pointer"
              >
                <i className="ri-send-plane-line mr-2"></i>
                我要爆料
              </a>
            </div>
          </div>

          <div className="flex-shrink-0 w-full max-w-[360px] md:max-w-[420px] lg:max-w-[460px]">
            <div className="relative aspect-[3/4] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20stylized%20illustration%20of%20news%20and%20gossip%20aggregation%2C%20collage%20of%20newspaper%20fragments%20floating%20in%20warm%20golden%20light%2C%20abstract%20magazine%20editorial%20style%2C%20coral%20red%20and%20amber%20accents%2C%20cinematic%20dramatic%20atmosphere%2C%20layered%20paper%20textures%2C%20motion%20blur%20effect%2C%20bold%20composition&width=600&height=800&seq=gossip-hero-visual&orientation=portrait"
                alt="爆料吃瓜 - 热门八卦与实时瓜料聚合导航"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}